<template>
  <div class="bg-bk news" id="bg-inversion">
    <h2>NEWS</h2>
    <ul v-if="articles.length">
      <li v-for="article in articles" :key="article.id">
        <p>{{ filterDate(article.date) }}</p>
        <h3><router-link :to="`/news/${article.slug}/`">{{ article.title.rendered }}</router-link></h3>
      </li>
    </ul>
  </div>
</template>

<script>
import cf from '@/mixins/commonFunctions.js';

export default {
  name: 'News',
  mixins: [cf],
  data() {
    return {
      articles: [],
    };
  },
  created() {
    this.getArticles();
  },
  methods: {
    async getArticles() {
      try {
        const articles = await this.axios({
          method: 'GET',
          url: '/genews/',
        });
        if (articles.data.length) {
          this.articles = articles.data;
        }
      } catch (e) {
        console.log(e.response?.data || e);
      }
    },
  },
};
</script>

<style scoped lang="scss">
</style>
